import Header from './components/Header';
import Hero from './components/Hero';
import Conversation from './components/Conversation';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#F7F4EE] text-[#222735]">
      <Header />
      <Hero />
      <div id="conversation-section">
        <Conversation />
      </div>
      <Footer />
    </div>
  );
}
